module.exports = {"information":"Información","waiting":"Esperando la validación"};